import Color from './color/color'
const store = {
  color: Color.create({})
};

window.app = store;

export default store;
